import { render, staticRenderFns } from "./SectionParking.vue?vue&type=template&id=54d18134&"
import script from "./SectionParking.vue?vue&type=script&lang=js&"
export * from "./SectionParking.vue?vue&type=script&lang=js&"
import style0 from "./SectionParking.vue?vue&type=style&index=0&id=54d18134&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports